// mds-dojo — dijit/form/_currency — FAITHFUL port of references/dojo/currency.js
// (+ inlined dojo/cldr/monetary.getData and the en/root dojo/cldr/nls/currency bundle).
//
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// !!! FLAG — WHY THIS FILE EXISTS (adaptation, not a stub):
// !!! mds has NO `dojo/currency` module and editing files outside dijit/form/ is out of scope,
// !!! so dojo/currency is ported here FAITHFULLY. Two behavioral notes vs. real dojo:
// !!!  1. LOCALE: no dojo/i18n loader — the currency-symbol bundle (dojo/cldr/nls/currency, en+root)
// !!!     and cldr/monetary fraction table are inlined below; the `locale` option is ignored.
// !!!  2. FORMAT SYMBOL: currency.format() delegates to the canonical mds dojo/number.format, which
// !!!     is a slim en-only formatter that does NOT render the currency pattern's ¤ symbol — so
// !!!     the *displayed* value lacks the "$"/"€" glyph. Fixing that would require editing the
// !!!     out-of-scope dojo/number.ts. currency.regexp()/parse() ARE symbol-aware (the ported
// !!!     _numberRegexp handles the ¤ placeholder), so validation of symboled input still works.
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
import darray from '../../dojo/_base/array'; // array.forEach
import lang from '../../dojo/_base/lang'; // lang.mixin
import baseNumber from '../../dojo/number'; // number.format number.parse
import numberRegexp from './_numberRegexp'; // number.regexp

// Composed dojo/number (same as NumberTextBox's): slim format/parse + ported regexp.
var dnumber: any = {
	format: baseNumber.format,
	parse: baseNumber.parse,
	regexp: numberRegexp.regexp
};

// Inlined dojo/cldr/nls/currency (root merged with en overrides) — replaces i18n.getLocalization.
var currencyBundle: any = {
	USD_symbol: "$", CAD_symbol: "CA$", GBP_symbol: "£", HKD_symbol: "HK$",
	JPY_symbol: "¥", AUD_symbol: "A$", CNY_symbol: "CN¥", EUR_symbol: "€",
	USD_displayName: "US Dollar", CAD_displayName: "Canadian Dollar",
	GBP_displayName: "British Pound", HKD_displayName: "Hong Kong Dollar",
	JPY_displayName: "Japanese Yen", AUD_displayName: "Australian Dollar",
	CNY_displayName: "Chinese Yuan", EUR_displayName: "Euro",
	CHF_displayName: "Swiss Franc"
};

// Inlined dojo/cldr/monetary.getData — currency-specific fraction (places) info.
var getMonetaryData = function (/*String*/ code: any) {
	var placesData: any = {
		ADP: 0, AFN: 0, ALL: 0, AMD: 0, BHD: 3, BIF: 0, BYR: 0, CLF: 0, CLP: 0,
		COP: 2, CRC: 0, DJF: 0, ESP: 0, GNF: 0, GYD: 0, HUF: 0, IDR: 0, IQD: 0,
		IRR: 3, ISK: 0, ITL: 0, JOD: 3, JPY: 0, KMF: 0, KPW: 0, KRW: 0, KWD: 3,
		LAK: 0, LBP: 0, LUF: 0, LYD: 3, MGA: 0, MGF: 0, MMK: 0, MNT: 0, MRO: 0,
		MUR: 0, OMR: 3, PKR: 2, PYG: 0, RSD: 0, RWF: 0, SLL: 0, SOS: 0, STD: 0,
		SYP: 0, TMM: 0, TND: 3, TRL: 0, TZS: 0, UGX: 0, UZS: 0, VND: 0, VUV: 0,
		XAF: 0, XOF: 0, XPF: 0, YER: 0, ZMK: 0, ZWD: 0
	};
	var roundingData: any = {};
	var places = placesData[code], round = roundingData[code];
	if (typeof places == "undefined") { places = 2; }
	if (typeof round == "undefined") { round = 0; }
	return { places: places, round: round }; // Object
};

var currency: any = {
	// summary:
	//		localized formatting and parsing routines for currencies
};

currency._mixInDefaults = function (options: any) {
	options = options || {};
	options.type = "currency";

	// Get locale-dependent currency data, like the symbol
	var bundle = currencyBundle || {};

	// Mixin locale-independent currency data, like # of places
	var iso = options.currency;
	var data: any = getMonetaryData(iso);

	darray.forEach(["displayName", "symbol", "group", "decimal"], function (prop: any) {
		data[prop] = bundle[iso + "_" + prop];
	});

	data.fractional = [true, false];

	// Mixin with provided options
	return lang.mixin(data, options);
};

currency.format = function (/*Number*/ value: any, /*__FormatOptions?*/ options: any) {
	// summary:
	//		Format a Number as a currency, using locale-specific settings
	return dnumber.format(value, currency._mixInDefaults(options));
};

currency.regexp = function (/*dnumber.__RegexpOptions?*/ options: any) {
	// summary:
	//		Builds the regular needed to parse a currency value
	return dnumber.regexp(currency._mixInDefaults(options)); // String
};

currency.parse = function (/*String*/ expression: any, /*__ParseOptions?*/ options: any) {
	// summary:
	//		Convert a properly formatted currency string to a primitive Number,
	//		using locale-specific settings.
	return dnumber.parse(expression, currency._mixInDefaults(options));
};

export default currency;
